import type {
    GetMoneyPage_maUrl_automation_actions as AutomationAction,
    GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables as Notifiables,
} from 'nutshell-graphql-types';
import {LeadAssigneeRuleEnum} from 'nutshell-graphql-types';

export function getSubtitleForAction(action: AutomationAction): string | null | undefined {
    const {config} = action;

    // Have to use __typename because Flow doesn't correlate action.type with config type
    switch (config.__typename) {
        case 'ActionConfigAddTags':
            return config.tags.map((tag) => tag.name).join(', ') || null;
        case 'ActionConfigAddAudiences':
            return config.audiences.map((audience) => audience.name).join(', ') || null;
        case 'ActionConfigRemoveAudiences':
            return config.audiences.map((audience) => audience.name).join(', ') || null;
        case 'ActionConfigAddToDripSequence':
            return config.dripSequence.name;
        case 'ActionConfigSendPageViewedNotification':
            return getNotificationSubtitle(config.notifiables);
        case 'ActionConfigCreateLead':
            return getCreateLeadSubtitle(config);
        default:
            return null;
    }
}

function getNotificationSubtitle(notifiables: Notifiables[]): string {
    return notifiables
        .map((notifiable) => {
            if (notifiable.__typename === 'User') {
                return notifiable.name;
            } else if (notifiable.type === 'RELATED_LEAD_ASSIGNEE') {
                return 'Lead assignee';
            } else if (notifiable.type === 'CONTACT_ASSIGNEE') {
                return 'Person assignee';
            }

            return null;
        })
        .filter((notifiable) => notifiable !== null)
        .join(', ');
}

function getCreateLeadSubtitle(config: any): string {
    const subtitle: string[] = [];

    if (config.stageset?.name) {
        subtitle.push(config.stageset.name);
    }

    const assigneeOrRule = config.assigneeOrRule;

    if (assigneeOrRule) {
        if (assigneeOrRule.__typename === 'User' || assigneeOrRule.__typename === 'Team') {
            subtitle.push(assigneeOrRule.name);
        } else if (assigneeOrRule.__typename === 'LeadAssigneeRule') {
            if (assigneeOrRule.assignmentRule === LeadAssigneeRuleEnum.AUTO_ASSIGN) {
                subtitle.push('Auto-assign');
            } else if (
                assigneeOrRule.assignmentRule === LeadAssigneeRuleEnum.ASSIGN_TO_CONTACT_ASSIGNEE
            ) {
                subtitle.push('Person assignee');
            }
        }
    }

    if (config.tags && config.tags.length > 0) {
        const tagNames = config.tags.map((tag: any) => tag.name).join(', ');

        subtitle.push(tagNames);
    }

    return subtitle.join(', ');
}
